/* WheelsUp Vehicle Gallery (sections/wu-vehicle-gallery.liquid): filtr Car/Model, Načíst další, lightbox s odkazem na kolekci */
if (!customElements.get('wu-vehicle-gallery')) {
  customElements.define('wu-vehicle-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.items = Array.from(this.querySelectorAll('[data-wu-vg-item]'));
      this.perPage = parseInt(this.dataset.perPage, 10) || 0;
      this.page = 1;
      this.carSel = this.querySelector('[data-wu-vg-car]');
      this.modelSel = this.querySelector('[data-wu-vg-model]');
      this.modelPlaceholder = this.modelSel ? this.modelSel.options[0].text : '';
      this.allLabel = this.carSel ? this.carSel.options[0].text : '';
      this.more = this.querySelector('[data-wu-vg-more]');
      this.dialog = this.querySelector('[data-wu-vg-dialog]');

      if (this.carSel) {
        this.fill(this.carSel, this.unique(this.items, 'car'), this.allLabel);
        this.carSel.addEventListener('change', () => {
          const models = this.unique(this.items.filter((i) => i.dataset.car === this.carSel.value), 'model');
          this.modelSel.disabled = !this.carSel.value;
          this.fill(this.modelSel, this.carSel.value ? models : [], this.carSel.value ? this.allLabel : this.modelPlaceholder);
          this.page = 1;
          this.apply();
        });
        this.modelSel.addEventListener('change', () => { this.page = 1; this.apply(); });
      }
      if (this.more) this.more.addEventListener('click', () => { this.page++; this.apply(); });

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-wu-vg-open]');
        if (!btn) return;
        e.preventDefault();
        this.open(this.visible().indexOf(btn.closest('[data-wu-vg-item]')));
      });

      if (this.dialog) {
        this.dialog.querySelector('[data-wu-vg-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.querySelector('[data-wu-vg-prev]').addEventListener('click', () => this.open(this.index - 1));
        this.dialog.querySelector('[data-wu-vg-next]').addEventListener('click', () => this.open(this.index + 1));
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog || e.target.classList.contains('wu-vg-lb__inner')) this.dialog.close(); });
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.open(this.index - 1);
          if (e.key === 'ArrowRight') this.open(this.index + 1);
        });
        let x0 = null;
        this.dialog.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.dialog.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 50) this.open(this.index + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
      this.apply();
    }

    unique(items, key) {
      return Array.from(new Set(items.map((i) => i.dataset[key]).filter(Boolean))).sort((a, b) => a.localeCompare(b));
    }

    fill(select, values, first) {
      select.innerHTML = '';
      select.add(new Option(first, ''));
      values.forEach((v) => select.add(new Option(v, v)));
    }

    matching() {
      const car = this.carSel ? this.carSel.value : '';
      const model = this.modelSel ? this.modelSel.value : '';
      return this.items.filter((i) => (!car || i.dataset.car === car) && (!model || i.dataset.model === model));
    }

    visible() {
      return this.items.filter((i) => !i.hidden);
    }

    apply() {
      const match = this.matching();
      const limit = this.perPage ? this.perPage * this.page : match.length;
      this.items.forEach((i) => { i.hidden = true; });
      match.slice(0, limit).forEach((i) => { i.hidden = false; });
      if (this.more) this.more.hidden = match.length <= limit;
      const slider = this.querySelector('slider-element');
      if (slider) slider.dispatchEvent(new Event('resize'));
    }

    open(index) {
      const list = this.visible();
      if (!this.dialog || index < 0 || index >= list.length) return;
      this.index = index;
      const d = list[index].dataset;
      const img = this.dialog.querySelector('[data-wu-vg-img]');
      img.src = d.src;
      img.alt = d.title || '';
      if (d.width) img.width = d.width;
      if (d.height) img.height = d.height;
      const meta = [d.car, d.model].filter(Boolean).join(' · ');
      const title = this.dialog.querySelector('[data-wu-vg-title]');
      title.textContent = d.title || '';
      title.hidden = !!d.colUrl;
      const link = this.dialog.querySelector('[data-wu-vg-link]');
      link.hidden = !d.colUrl;
      link.href = d.colUrl || '#';
      this.dialog.querySelector('[data-wu-vg-meta]').textContent = meta;
      this.dialog.querySelector('[data-wu-vg-col]').textContent = d.colTitle || '';
      const thumb = this.dialog.querySelector('[data-wu-vg-thumb]');
      this.dialog.querySelector('[data-wu-vg-thumb-wrap]').hidden = !d.colImg;
      if (d.colImg) { thumb.src = d.colImg; thumb.alt = d.colTitle || ''; }
      this.dialog.querySelector('[data-wu-vg-prev]').disabled = index === 0;
      this.dialog.querySelector('[data-wu-vg-next]').disabled = index === list.length - 1;
      if (!this.dialog.open) {
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      }
      [list[index - 1], list[index + 1]].forEach((n) => { if (n) new Image().src = n.dataset.src; });
    }
  });
}
